<template>
  <div class="Browser"
    :class="{ 'Browser--suiteIsUnoccupied': suiteIsUnoccupied }">

    <div class="Browser-messages"
      v-if="suiteIsUnoccupied">

      <messages
        ref="messages"
        :content="[]"
        :alt-colors="true" />

    </div>

    <div class="Browser-header"
      v-if="showBrowserHeader">

      <div class="Browser-icon"
        v-if="animal"
        :style="{ 'background-image': `url(${animal.image})` }">
      </div>

      <div class="Browser-title"
        v-if="animal">
        {{ animal.name  }}
      </div>

      <div class="Browser-suiteInfo">

        <div class="Browser-suiteInfoContent">

          <p class="Browser-suiteTitle">Suite</p>

          <p class="Browser-suiteNumber">{{ suite.suiteNumber }}</p>

        </div>

      </div>

    </div>

    <status-badge class="Browser-statusBadge"
      v-if="!animal.available" />

    <div class="Browser-content">

      <div class="Browser-container">

        <div class="Browser-handle Browser-handle--top">

          <icon class="Browser-handleIcon"
            name="pull-tab-top"
            width="72.36px"
            height="13.09px" />

        </div>

        <div class="Browser-windowBorder"
          :class="{ 'Browser-windowBorder--showColor': this.showCircleBorder }">

          <div class="Browser-window">

            <div class="Browser-selectorButton"
              @click="goToAttract"
              v-if="animals.length > 1">

              <icon class="Browser-selectorButtonIcon"
                name="home"
                width="21.98px"
                height="20.14px" />

                <div class="Browser-selectorButtonLabel">Change Pet</div>

            </div>

            <menu-component />

            <div class="Browser-windowContent">

              <transition name="Browser-windowContent-">

                <router-view class="Browser-windowContentItem" />

              </transition>

            </div>

          </div>

        </div>

        <div class="Browser-handle Browser-handle--bottom">

          <icon class="Browser-handleIcon"
            name="pull-tab-bottom"
            width="72.36px"
            height="13.09px" />

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import Icon from 'components/Icon'
import MenuComponent from 'components/Menu'
import Messages from 'components/Messages'
import StatusBadge from 'components/StatusBadge'
import Draggabilly from 'draggabilly'

export default {
  name: 'Browser',

  components: {
    Icon,
    MenuComponent,
    Messages,
    StatusBadge
  },

  mounted () {
    this.$nextTick(this.init)
  },

  computed: {
    animal () { return this.$store.state.animal },
    animals () { return this.$store.state.animals },
    suite () { return this.$store.state.suite },
    suiteIsUnoccupied () { return this.$store.state.suiteIsUnoccupied },
    showCircleBorder () { return this.$store.state.showCircleBorder },
    idleTime () { return this.$store.state.idleTime },
    showBrowserHeader () { return !this.$store.state.suiteIsUnoccupied }
  },

  watch: {
    idleTime () {
      this.$store.dispatch('setDataRefreshTimestamp', new Date().getTime())

      // End analytics session
      this.$analytics.end()

      // If the suite is unoccupied, request a data refresh but go to About
      // instead of Attract
      if (this.suiteIsUnoccupied) {
        this.$router.push({ name: 'about' })
        return
      }

      // Go to attract
      this.$router.push({ name: 'attract' })
    }
  },

  methods: {
    /**
     * Initialize
     */
    init () {
      // Begin analytics session
      this.$analytics.begin()

      this.handle = new Draggabilly('.Browser-container', {
        axis: 'y',
        containment: '.Browser-content',
        handle: '.Browser-handle'
      })
    },

    goToAttract () {
      this.$router.push({ name: 'attract' })
    }
  }
}
</script>

<style>
.Browser {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
}

.Browser-header {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 68px 68px 0;
  padding: 42px;
  border-radius: 60px;
  background-color: var(--color-1);
}

.Browser-messages {
  padding: 68px;
  height: 450px;
}

.Browser-icon {
  flex-shrink: 0;
  width: 112px;
  height: 112px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 50%;
  border: 2px solid var(--color-3);
  overflow: hidden;
}

.Browser-title {
  position: relative;
  top: 8px;
  flex-grow: 1;
  padding: 0 36px;
  font-size: 97px;
  line-height: 1.1;
  font-weight: 500;
  color: var(--color-4);
}

.Browser-suiteInfo {
  flex-grow: 1;
  display: flex;
  justify-content: center;
}

.Browser-suiteInfoContent {
  text-align: center;
  color: var(--color-5);
}

.Browser-suiteTitle {
  margin-bottom: 4px;
  font-size: 16px;
  line-height: 1;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

.Browser-suiteNumber {
  font-size: 71.57px;
  line-height: 1;
}

.Browser-statusBadge {
  position: absolute;
  z-index: 1;
  top: 133px;
  left: 50%;
  margin-left: -132.5px;
  width: 265px;
  height: 265px;
  font-size: 25px;
  line-height: 34px;
  letter-spacing: 0.02em;
  font-weight: 600;
  -webkit-font-smoothing: antialiased;
}

.Browser-statusBadge .StatusBadge-label {
  top: 56px;
}

/**
 * Defines the bounds for 'window' dragging.
 */
.Browser-content {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 117px;
  margin-bottom: 117px;
}

.Browser-container {
  position: relative;
  z-index: 100;
}

.Browser--suiteIsUnoccupied .Browser-container {
  top: -94px;
}

.Browser-windowBorder {
  border-radius: 50%;
  border: 2px solid var(--color-1);
  transition: border-color 1s ease;
}

.Browser-windowBorder--showColor {
  border-color: var(--color-3);
}

.Browser-window {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 930px;
  height: 930px;
}

.Browser-selectorButton {
  position: absolute;
  top: -10px;
  left: -10px;
  display: flex;
  align-items: center;
  padding: 12px 20px;
  background-color: var(--color-5);
  border-radius: 28px;
  border: 2px solid var(--color-1);
}

.Browser-selectorButtonIcon {
  margin-right: 15px;
}

.Browser-selectorButtonLabel {
  padding-left: 15px;
  border-left: 1px solid var(--color-1);
  font-size: 19px;
  line-height: 1;
  font-weight: 500;
  color: var(--color-1);
  -webkit-font-smoothing: antialiased;
}

.Browser-windowContent {
  flex-grow: 1;
  display: flex;
  position: relative;
  width: 930px;
  height: 930px;
  clip-path: circle(50% at center);
  overflow: hidden;
  background-color: var(--color-1);
}

.Browser-windowContent--enter-active,
.Browser-windowContent--leave-active {
  transition: opacity 1s ease;
}

.Browser-windowContent--enter,
.Browser-windowContent--leave-to {
  opacity: 0;
}

.Browser-windowContentItem {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.Browser-handle {
  position: absolute;
  z-index: -1;
  left: 50%;
  display: flex;
  justify-content: center;
  margin-left: -60px;
  width: 120px;
  height: 120px;
  user-select: none;
  background: rgba(255,255,255,0.8);
  border-radius: 50%;
}

.Browser-handle--top {
  top: -60px;
  align-items: flex-start;
}

.Browser-handle--bottom {
  align-items: flex-end;
  bottom: -60px;
}

.Browser-handleIcon {
  position: relative;
  fill: var(--color-3);
}

.Browser-handle--top .Browser-handleIcon {
  top: 30px;
}

.Browser-handle--bottom .Browser-handleIcon {
  bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// Browser.vue?44c45b90